import analytics from '@/Analytics';

import { useProjectContextStore } from '@/Stores/Web/projectContextStore';

// The payment options component builds these payloads - here they only get an event name and the project context.
export function usePaymentAnalytics() {
    const projectContextStore = useProjectContextStore();

    function track(event, payload) {
        analytics.track(event, payload, projectContextStore.projectContext);
    }

    return {
        trackPaymentError: payload => track('payment_error', payload),
        trackPaymentGroupVisibilityToggle: payload => track('checkout_payment_section_visibility_toggle', payload),
        trackPaymentMethodChange: payload => track('checkout_payment_method_change', payload),
    };
}
